// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-pic[data-v-79a19149]{width:80px;height:80px}.ic_call[data-v-79a19149]{width:17px;height:17px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
